export const GOOGLE_SYNCED_BLOCK_ID = '0'

export const isGoogleSyncedBlock = block =>
  String(block?.id) === GOOGLE_SYNCED_BLOCK_ID

export const SYNCED_BLOCK_TOOLTIP =
  'Synced from your connected calendar. This time is not editable here.'

export const AVAILABILITY_BLOCK_COLORS = {
  recurring: {
    backgroundColor: '#BEF1BB',
    color: '#00210B',
    border: '#7BC67E',
  },
  override: {
    backgroundColor: '#7BC67E',
    color: '#00210B',
    border: '#3B873E',
  },
  blocked: {
    backgroundColor: '#FFBCBC',
    color: '#410002',
    border: '#E57373',
  },
  synced: {
    backgroundColor: '#E57373',
    color: '#410002',
    border: '#C62828',
  },
}

export const availabilityFill = variant => {
  const { backgroundColor, color, border } = AVAILABILITY_BLOCK_COLORS[variant]
  return {
    backgroundColor,
    color,
    boxShadow: `inset 0 0 0 1px ${border}`,
  }
}

export const availabilityDot = variant => {
  const { backgroundColor, border } = AVAILABILITY_BLOCK_COLORS[variant]
  return {
    backgroundColor,
    boxShadow: `inset 0 0 0 1px ${border}`,
  }
}
